var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.0002,
    height: 18.0002,
    viewBox: "0 0 18.0002 18.0002",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0002 17.0002L13.1398 13.1398M13.1398 13.1398C13.8001 12.4794 14.3239 11.6955 14.6813 10.8327C15.0387 9.9699 15.2226 9.04517 15.2226 8.1113C15.2226 7.17743 15.0387 6.25271 14.6813 5.38993C14.3239 4.52714 13.8001 3.7432 13.1398 3.08285C12.4794 2.42251 11.6955 1.89869 10.8327 1.54132C9.9699 1.18394 9.04517 1 8.1113 1C7.17743 1 6.25271 1.18394 5.38993 1.54132C4.52714 1.89869 3.7432 2.42251 3.08285 3.08285C1.74922 4.41648 1 6.22527 1 8.1113C1 9.99734 1.74922 11.8061 3.08285 13.1398C4.41648 14.4734 6.22527 15.2226 8.1113 15.2226C9.99734 15.2226 11.8061 14.4734 13.1398 13.1398Z",
    stroke: "#1638B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.20daaa51c97d2e158a1c68367ad00cb4.svg";
export { ForwardRef as ReactComponent };